import dayjs from 'dayjs';

import { useAppSelector } from '@verantos-dev/core-annotation-tool';

import { useGetIRRScoreDataQuery } from '../api/metricsApiSlice';
import {
  selectIRRFilterTypeId,
  selectIRRScoreBatchTypeId,
  selectIRRScoreDate,
  selectSelectedProjectId,
} from '../state/selector';

export const useIRRScoreDatagridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetIRRScoreDataQuery> => {
  const selectedProjectId = useAppSelector(selectSelectedProjectId);
  const batchTypeId = useAppSelector(selectIRRScoreBatchTypeId);
  const filterTypeId = useAppSelector(selectIRRFilterTypeId);
  const date = useAppSelector(selectIRRScoreDate);

  return useGetIRRScoreDataQuery(
    {
      batchTypeId: batchTypeId || '',
      projectId: selectedProjectId || '',
      filterTypeId: filterTypeId || '',
      date: date ? dayjs(date).format('YYYY-MM-DD') : undefined,
    },
    { skip: !(selectedProjectId && batchTypeId) }
  );
};
